module.exports = __webpack_public_path__ + "static/media/room-users-queue.46de7036.svg";